import { useTranslation } from '../../../hooks/useTranslation';

export type Step = {
  id: string;
  number: string;
  title: string;
  description: string;
};

export const useHowItWorks = () => {
  const { t } = useTranslation();

  const data = {
    label: t('home.howItWorks.label'),
    title: t('home.howItWorks.title'),
    steps: [
      {
        id: 'step1',
        number: t('home.howItWorks.step1.number'),
        title: t('home.howItWorks.step1.title'),
        description: t('home.howItWorks.step1.description'),
      },
      {
        id: 'step2',
        number: t('home.howItWorks.step2.number'),
        title: t('home.howItWorks.step2.title'),
        description: t('home.howItWorks.step2.description'),
      },
      {
        id: 'step3',
        number: t('home.howItWorks.step3.number'),
        title: t('home.howItWorks.step3.title'),
        description: t('home.howItWorks.step3.description'),
      },
    ],
  };

  return { data };
};

export type HowItWorksProps = ReturnType<typeof useHowItWorks>;
